var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaviconV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 7.20002C11.1741 7.20002 10.0996 6.12551 10.0996 4.80002C10.0996 3.47454 11.1741 2.40002 12.4996 2.40002C13.8251 2.40002 14.8996 3.47454 14.8996 4.80002C14.8996 6.12551 13.8251 7.20002 12.4996 7.20002Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 14.4C11.1741 14.4 10.0996 13.3255 10.0996 12C10.0996 10.6745 11.1741 9.60002 12.4996 9.60002C13.8251 9.60002 14.8996 10.6745 14.8996 12C14.8996 13.3255 13.8251 14.4 12.4996 14.4Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 21.6C11.1741 21.6 10.0996 20.5255 10.0996 19.2C10.0996 17.8745 11.1741 16.8 12.4996 16.8C13.8251 16.8 14.8996 17.8745 14.8996 19.2C14.8996 20.5255 13.8251 21.6 12.4996 21.6Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaviconV);
export default __webpack_public_path__ + "static/media/Navicon-v.0dd4a18b.svg";
export { ForwardRef as ReactComponent };